import globalStore from './globalStore'
import loginStore from './loginStore'
import formularioStore from './formularioStore'
import meusAgendamentosStore from './meusAgendamentosStore'
import adminAgendamentosStore from './adminAgendamentosStore'
import agendamentosTodosStore from './agendamentosTodosStore'

export default { 
  globalStore,
  loginStore,
  formularioStore,
  meusAgendamentosStore,
  adminAgendamentosStore,
  agendamentosTodosStore
}
